import {getHostWithProtocol} from "../../src/utils/urls";
import {OgProps, ValidOgPath} from "./ogPathMap";

export const getOgImagePath = <T extends ValidOgPath>(path: T, props: OgProps<T>): string => {
  const route = "/api/og";
  const query = new URLSearchParams({
    path: path,
    props: JSON.stringify(props),
  });
  return `${getHostWithProtocol()}${route}?${query}`;
};
